export const WeekTypeEnum = {
    CURRENT: 'current',
    NEXT: 'next',
};
